export default "__VITE_ASSET__fb9d7f27__"